<script>
export default {
  name: "calendarModal",
  data(){
    return {
      isActive:false,
      infoContract:[],
      isLeft: false
    }
  },
  methods:{
    showModal(sale, positionLeft){
      if (sale.id === this.infoContract.id){
        this.closeModal()
        $(".month-box.big-mobile").removeClass("open")
      } else {
        sale.sales_begin_format = moment(sale.sales_begin).format("DD.MM")
        sale.sales_end_format = moment(sale.sales_end).format("DD.MM")
        this.infoContract = sale
        this.isActive = !this.isActive
        this.checkToLeft(positionLeft)
      }
    },
    checkToLeft(positionLeft){
      let monthEl = $('.month-box')
      let difPosition = window.innerWidth - (positionLeft + monthEl.width() + (parseFloat($('.month-list').css("gap").split(" ") [1])))
      let needWidth = (monthEl.width() + parseFloat($('.month-list').css("gap").split(" ") [1])) * 1.1

      if (difPosition <= needWidth
          && window.innerWidth >=700){
        this.isLeft = true
      }
    },
    closeModal() {
      this.isActive = false;
    }
  }
}
</script>

<template>
  <Transition name="fade-cal-mob">
    <div class="block-calendar-modal left"
          :class="{
            'left-pos' : isLeft
          }"
        v-if="isActive">
      <div class="calendar-modal-box left">
        <span class="content-calendar-modal left">
          <span class="calendar-modal-title left">{{infoContract.partner}}</span>
          <span class="calendar-modal-date left flex flex-xy-center">{{infoContract.sales_begin_format}} - {{infoContract.sales_end_format}}</span>
          <span class="calendar-modal-contract left">Договор: <strong>{{infoContract.contract}}</strong></span>
          <span class="calendar-modal-sale left">Номер: <strong> {{infoContract.sales_number}}</strong></span>
          <span class="calendar-modal-sum">{{infoContract.sum.toLocaleString() }}
          <span class="calendar-money-ruble">₽</span>
          </span>
        </span>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-cal-mob-enter-active{

  transition:transform 0.3s ease, opacity 0.3s ease;
}
.fade-cal-mob-leave-active {
  transition:transform 0.23s ease, opacity 0.15s ease;
}

.fade-cal-mob-enter-from,
.fade-cal-mob-leave-to {
  opacity: 0;
  transform: translateY(5rem);
}
</style>